import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ClienteComponent} from '../../components/cliente/cliente.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageService} from '../services/page.service';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {NumPedidoModalComponent} from '../modal/num-pedido-modal/num-pedido-modal.component';

@Component({
  selector: 'app-reduccion',
  templateUrl: './reduccion.component.html',
  styleUrls: ['./reduccion.component.css']
})
export class ReduccionComponent implements OnInit, AfterContentChecked {
  @ViewChild('clienteComponent', {static: false}) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  formData: FormData;
  DatoCliente: any;
  isEditable = true;
  solicitud: string;


  constructor(private cdRef: ChangeDetectorRef, private fb: FormBuilder, private servicio: PageService,
              private dialog: MatDialog, private router: Router) {

  }


  ngOnInit(): void {
   this.inicio();
   this.numPedidoModal();
  }

  numPedidoModal(): void{
    const dialogRef2 = this.dialog.open(NumPedidoModalComponent, {
      width: '400px',

      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog'
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  inicio(): void {
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      usuarioweb: '',
      colaborador: '',
      tipoVehiculo: ['', [Validators.required]],
      bastidor: '',
      marca: '',
      modelo: '',
    });
  }

  siguiente(): void {
    console.log(this.datosVehiculos.value);
  }

  siguiente2($event: any): void {
    this.DatoCliente = {...$event, ...this.datosVehiculos.value};
    this.DatoCliente.tipo = 'REDUCCION';
    this.DatoCliente.numPedido = sessionStorage.getItem('numPedidoComun');
    this.DatoCliente.usuarioweb = sessionStorage.getItem('email');
    this.DatoCliente.colaborador = sessionStorage.getItem('colaborador');
    console.log(this.DatoCliente);
  }

  getSolicitud(): void {
    this.servicio.getOneSolicitud(this.solicitud).subscribe((res) => {
      this.setDatos(res);
    }, (error) => {
      console.log(error);
    });
  }

  setDatos(datos): void {
    this.datosVehiculos.controls.tipoVehiculo.setValue(datos.tipoVehiculo);
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
  }
}
